import { useCallback } from "react"
import { graphql } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  ReConcludeAppointmentInput,
  useReConcludeAppointmentMutation as useReConcludeAppointmentMutationType,
} from "@/modules/patients/services/__generated__/useReConcludeAppointmentMutation.graphql"
import useCallContextStore from "@/stores/useCallContextStore"

const reConcludeAppointmentMutation = graphql`
  mutation useReConcludeAppointmentMutation($input: ReConcludeAppointmentInput!) {
    reConcludeAppointment(input: $input) {
      appointment {
        id
        status
        isCompleted
        completedAt
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useReConcludeAppointmentMutation = () => {
  const [commit, isFlight] =
    useMutationWithErrorDialog<useReConcludeAppointmentMutationType>(reConcludeAppointmentMutation)

  const commitHandler = useCallback(
    (input: ReConcludeAppointmentInput, onCompleted?: () => void) => {
      return new Promise<void>((res) => {
        commit({
          variables: {
            input: {
              id: input.id,
              collectBillingInput: input.collectBillingInput,
              isEditWithin24Hours: input.isEditWithin24Hours,
              progressNoteIds: input.progressNoteIds,
              inboundCallId: useCallContextStore.getState().inboundCallId,
            },
          },
          onCompleted() {
            onCompleted?.()
            res()
          },
        })
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}
